import {
  Hospital,
  HospitalListDto,
  ID,
  QueryFilters,
  unwrapApiErrorDetails
} from '@ianesthesie-kit/services';
import { HospitalService } from '@/modules/hospital/hospital.service';
import { doctorBffApi } from '@/modules';

export const hospitalApi = doctorBffApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    hospitalById: builder.query<Hospital, ID>({
      keepUnusedDataFor: 120,
      providesTags: (result) =>
        result?.id ? [{ type: 'Hospital', id: result.id }] : [],
      queryFn: (id) =>
        HospitalService.getInstance()
          .fetchById(id)
          .then((r) => ({
            data: r.data
          }))
          .catch((err) => ({
            error: unwrapApiErrorDetails(err) || err
          }))
    }),
    hospitalList: builder.query<HospitalListDto[], QueryFilters | void>({
      queryFn: (filters) =>
        HospitalService.getInstance()
          .fetchAllDtos({
            pageSize: 2000,
            sort: 'name',
            ...filters
          })
          .then((r) => ({
            data: r.data
          }))
          .catch((err) => ({
            error: unwrapApiErrorDetails(err) || err
          }))
    })
  })
});

export const { useHospitalByIdQuery, useHospitalListQuery } = hospitalApi;
